export default "__VITE_ASSET__DudkY9JI__"